import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  const filled = 327;
  const total = 500;
  const pct = Math.round(filled / total * 100);
  return <section className="py-20 bg-white px-4" data-id="element-96">
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-97">
        {/* Urgency Block */}
        <div className="bg-[#9B4D4D] text-white rounded-2xl p-8 md:p-10 text-center" data-id="element-98">
          <p className="text-sm font-bold uppercase tracking-wider text-white/70 mb-3" data-id="element-99">
            ⏳ Este precio es temporal
          </p>
          <p className="text-lg text-white/90 mb-6 max-w-2xl mx-auto" data-id="element-100">
            Cuando las primeras 500 mujeres accedan, el precio vuelve a $47.
          </p>

          {/* Progress bar */}
          <div className="max-w-sm mx-auto mb-6" data-id="element-101">
            <div className="flex justify-between text-xs text-white/60 mb-1.5" data-id="element-102">
              <span data-id="element-103">{filled} accedieron</span>
              <span data-id="element-104">{total} cupos</span>
            </div>
            <div className="w-full bg-white/20 rounded-full h-3 overflow-hidden" data-id="element-105">
              <div className="bg-gradient-to-r from-red-400 to-red-500 h-3 rounded-full transition-all" style={{
              width: `${pct}%`
            }} data-id="element-106" />
            </div>
            <p className="text-xs text-white/50 mt-1.5" data-id="element-107">
              Quedan {total - filled} cupos al precio de lanzamiento
            </p>
          </div>

          <div data-id="element-108">
            <p className="text-sm text-white/50 line-through mb-1" data-id="element-109">
              Precio normal: $47
            </p>
            <p className="text-4xl font-bold" data-id="element-110">Hoy: $11.99</p>
            <p className="text-sm text-[#C4973B] font-semibold mt-1" data-id="element-111">
              Ahorras $35 hoy (77% descuento)
            </p>
            <p className="text-white/70 text-sm mt-1" data-id="element-112">
              📲 Acceso inmediato después del pago · Disponible desde tu
              teléfono
            </p>
          </div>
        </div>

        {/* Price comparison */}
        <div className="grid grid-cols-3 gap-4 text-center" data-id="element-113">
          {[{
          label: 'Sesión de terapia',
          price: '$80–150',
          note: 'una vez'
        }, {
          label: 'Calma-5™',
          price: '$11.99',
          note: 'de por vida',
          highlight: true
        }, {
          label: 'Café en una semana',
          price: '$15–25',
          note: 'se acaba'
        }].map((item, i) => <div key={i} className={`rounded-xl p-5 border ${item.highlight ? 'bg-[#FAF5EF] border-[#C4973B]/40 shadow-md' : 'bg-gray-50 border-gray-200'}`} data-id="element-114">
              <p className={`text-xl font-bold mb-1 ${item.highlight ? 'text-[#C06B6B]' : 'text-gray-700'}`} data-id="element-115">
                {item.price}
              </p>
              <p className="text-sm text-gray-600 font-medium" data-id="element-116">{item.label}</p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-117">{item.note}</p>
            </div>)}
        </div>
        <p className="text-center text-[#C06B6B] font-semibold -mt-6" data-id="element-118">
          Y lo usas hoy mismo.
        </p>

        {/* Guarantee */}
        <div className="text-center max-w-2xl mx-auto" data-id="element-119">
          <ShieldCheck className="h-16 w-16 text-[#C06B6B] mx-auto mb-6" data-id="element-120" />
          <h2 className="text-3xl font-serif font-bold text-gray-900 mb-4" data-id="element-121">
            Garantía total de 7 días
          </h2>
          <p className="text-lg text-gray-600" data-id="element-122">
            Si no sientes alivio físico real… Te devolvemos tu dinero.
          </p>
          <p className="text-lg font-medium text-gray-800 mt-2" data-id="element-123">
            Sin preguntas. Sin fricción.
          </p>
        </div>
      </div>
    </section>;
}